import _ from 'lodash';
import * as api from './api';
import * as yup from 'yup';
import * as helpers from 'services/helpers';

export const fetchAPILogs = async (params) => {
  try {
    let res = await api.fetchAPILogs(params);
    return res;
  } catch (err) {
    throw err;
  }
};

export const fetchExceptionLogs = async (params) => {
  try {
    let res = await api.fetchExceptionLogs(params);
    return res;
  } catch (err) {
    throw err;
  }
};

export const saveUpdateVendor = async (params) => {
  try {
    let res = await api.saveUpdateVendor(params);
    return res;
  } catch (err) {
    throw err;
  }
};

export const saveUpdateCustomer = async (params) => {
  try {
    let res = await api.saveUpdateCustomer(params);
    return res;
  } catch (err) {
    throw err;
  }
};

export const saveUpdateTaxInfo = async (params) => {
  try {
    let res = await api.saveUpdateTaxInfo(params);
    return res;
  } catch (err) {
    throw err;
  }
};

export const saveUpdateAddress = async (params) => {
  try {
    let res = await api.saveUpdateAddress(params);
    return res;
  } catch (err) {
    throw err;
  }
};

export const saveUpdateInvoice = async (params) => {
  try {
    let res = await api.saveUpdateInvoice(params);
    return res;
  } catch (err) {
    throw err;
  }
};
